import http from "../plugins/axios";

const loadNotices = async (params = {}) => {
    const response = await http.get('/api/company/v3/push', {params});
    return response.data;
};

const loadNotice = async (id) => {
    const response = await http.get('/api/company/v3/push/' + id);
    return response.data;
};

const createNotice = async (body) => {
    const response = await http.post('/api/company/v3/push', body);
    return response.data;
};

const updateNotice = async (id, body) => {
    const response = await http.post('/api/company/v3/push/' + id, body);
    return response.data;
};

const deleteNotice = async (id) => {
    const response = await http.get('/api/company/v3/push/' + id + '/delete');
    return response.data;
};

export {loadNotices, loadNotice, createNotice, updateNotice, deleteNotice};